import { render, staticRenderFns } from "./SharedInvoice.vue?vue&type=template&id=23415292&scoped=true&"
import script from "./SharedInvoice.vue?vue&type=script&lang=ts&"
export * from "./SharedInvoice.vue?vue&type=script&lang=ts&"
import style0 from "./SharedInvoice.vue?vue&type=style&index=0&id=23415292&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "23415292",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VContainer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VContainer})
